import styled from 'styled-components';
import { Section, SectionHeader } from '../../../../../styling/FormStyling';
import { ColumnFlex3 } from '../../../../../styling/Styling';
import { TaskTypeExternalResourceDTO } from '../../../../../api/api';
import Hyperlink from '../../../../../components/hyperlink/HyperLink';

interface Props {
  externalLinks?: TaskTypeExternalResourceDTO[];
}

export const ExternalResources = (props: Props) => {
  const { externalLinks } = props;

  return (
    <>
      {externalLinks && externalLinks?.length > 0 && (
        <Section>
          <SectionHeader>Links</SectionHeader>
          <StyledColumnFlex>
            {externalLinks
              ?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
              .map((l) => {
                return <Hyperlink label={l.name} link={l.url} />;
              })}
          </StyledColumnFlex>
        </Section>
      )}
    </>
  );
};

const StyledColumnFlex = styled(ColumnFlex3)`
  justify-content: space-between;
  width: 50%;
`;
